import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/axios.js';

export function useObjetivo(mes, anio) {
  return useQuery({
    queryKey: ['objetivo', mes, anio],
    queryFn: () => api.get('/objetivos', { params: { mes, anio } }).then((r) => r.data),
  });
}

export function useUpsertObjetivo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.put('/objetivos', data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['objetivo'] }),
  });
}
